export const validation = {
  maxTitleChar: 120,
  maxParagraphChar: 1500,
  musicUrls: {
    min: 1,
    max: 12
  }
}
